// Boostrap modals
( function($, waTheme) {

    var BootstrapModals = (function ($) {

        BootstrapModals = function (options) {
            var that = this;

            // DOM
            that.$wrapper = options['$wrapper'];

            // VARS
            that.modal_id = options['modal_id'];

            // DYNAMIC VARS

            // EVENTS
            that.bindEvents();
        };

        BootstrapModals.prototype.bindEvents = function () {
            var that = this;

            $(document).on("click", `.${that.modal_id}Show, a[href="#${that.modal_id}Show"]`, function (event) {
                event.preventDefault();
                that.$wrapper.modal("show");
            });
        }

        return BootstrapModals;

    })($);

    waTheme.init.site.BootstrapModals = BootstrapModals;

    var modals = ["sellerFeedbackModal"];
    for (const modal of modals) {
        var $modal = $(`#${modal}`);
        if ($modal.length) {
            new window.waTheme.init.site.BootstrapModals({
                $wrapper: $modal,
                modal_id: modal
            });
        }
    }

})(jQuery, window.waTheme);